const MintLink =
  "https://www.livemint.com/Companies/NfLROydKMDH8TLVirMLe6K/Ondemand-driver-service-to-rival-Ola-Uber-launched.html";
const ToiLink =
  "https://timesofindia.indiatimes.com/tech-news/every-day-i-wait-for-a-new-problem-rahm-shastry-investor-taxiforsure/articleshow/51422479.cms";
const TheIndianExpressLink =
  "https://www.newindianexpress.com/cities/bengaluru/2015/aug/18/Driver-By-the-Hour-Tap-Here-800975.html";
const YsLink = "https://yourstory.com/2015/07/driveu-on-demand-drivers/amp";
const NewYorkTimesLink =
  "https://www.nytimes.com/2016/04/12/business/dealbook/for-indian-start-ups-tenacity-beats-high-tech.html?_r=0";
const CNBC18Link =
  "https://twitter.com/driveu_in/status/1427278796877570053?s=20";

const NewsIcon = {
  Mint: "https://ik.imagekit.io/driveu/Website_New/mint_ttu4idXdY.png",
  Cnbc18: "https://ik.imagekit.io/driveu/Website_New/cnbc18_nEl_YAzsk.png",
  IndianExpress:
    "https://ik.imagekit.io/driveu/Website_New/indian_express_AwpwJxVPw.png",
  Ys: "https://ik.imagekit.io/driveu/Website_New/ys_9ZfVxC4h4.png",
  NewyorkTimes:
    "https://ik.imagekit.io/driveu/Website_New/newyorktimes_noK8GIcpZ.png",
  Toi: "https://ik.imagekit.io/driveu/Website_New/toi_ye65ux1Wa.png",
};
const NewsIconMobile = {
  Cnbc18Mobile:
    "https://ik.imagekit.io/driveu/Website_New/CnbcMobile_CvEz0ataX.png",
  NewyorkTimesMobile:
    "https://ik.imagekit.io/driveu/Website_New/NewYorkTimesMobile_Gq5kC_j6D.png",
  ToiMobile:
    "https://ik.imagekit.io/driveu/Website_New/ToiMobile_FAYLj_dOT.png",
  YsMobile: "https://ik.imagekit.io/driveu/Website_New/YsMobile_2qlotEdBR.png",
  MintMobile:
    "https://ik.imagekit.io/driveu/Website_New/MintMobile_ihkPsK2jPJ.png",
  IndianExpressMobile:
    "https://ik.imagekit.io/driveu/Website_New/TheIndianExpressMobile_-mEhsh5gs.png",
};

const imgArr = [
  NewsIcon.Mint,
  NewsIcon.Cnbc18,
  NewsIcon.IndianExpress,
  NewsIcon.Ys,
  NewsIcon.NewyorkTimes,
  NewsIcon.Toi,
];
const imgArrMobile = [
  NewsIconMobile.Cnbc18Mobile,
  NewsIconMobile.NewyorkTimesMobile,
  NewsIconMobile.ToiMobile,
  NewsIconMobile.YsMobile,
  NewsIconMobile.MintMobile,
  NewsIconMobile.IndianExpressMobile,
];

export {
  MintLink,
  ToiLink,
  TheIndianExpressLink,
  YsLink,
  NewYorkTimesLink,
  CNBC18Link,
  imgArr,
  imgArrMobile,
};
